import React from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { withStyles } from '@material-ui/core/styles';

const style = {
  tooltipUp: {
    span: {

    },
    before: {

    },
  },
  tooltipDown: {
    span: {

    },
    before: {

    },
  },
};

export default class IPButton extends React.Component {
  constructor() {
    super();
    this.state = { copied: false };
    this.copyIP = this.copyIP.bind(this);
    this.outCopy = this.outCopy.bind(this);
  }

  copyIP() {
    this.setState({ copied: true });
  }

  outCopy() {
    setTimeout(() => {
      this.setState({ copied: false });
    }, 300);
  }

  render() {
    const { copied } = this.state;
    return (
      <CopyToClipboard
        text="bloodybattle.net"
        onCopy={this.copyIP}
        onBlur={this.outCopy}
        onMouseOut={this.outCopy}
      >
        <span>{copied ? 'IP copiée !' : 'bloodybattle.net (Copier l\'ip)'}</span>
      </CopyToClipboard>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layout/IPButton.js